// extracted by mini-css-extract-plugin
export var container = "_pz-0";
export var dotAnimation = "_pz-2";
export var dotsLoading = "_pz-1";